import { PlusOutlined, PrinterOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import React, { useState } from 'react';
import { _T } from '../../../../../base-react/src/Localization';
import { TeamEdit } from './TeamEdit';
import { hooks, models } from "@vote4dance/judging-sdk";
var Stream = hooks.streams.Stream;
var TeamItemSource = models.teams.TeamItemSource;
import { Link } from 'react-router-dom';
import { AssignStartNumbers } from './AssignStartNumbers';
export const TeamsToolbar = (props) => {
    const { competition_id, team_id, disabled } = props;
    const [visibleEdit, setVisibleEdit] = useState(!!team_id);
    const [teamItem] = Stream(team_id ? TeamItemSource(competition_id, team_id) : undefined);
    return (React.createElement(Space, { wrap: true },
        React.createElement(Button, { key: "create", type: "primary", disabled: disabled, icon: React.createElement(PlusOutlined, null), onClick: () => setVisibleEdit(true) }, _T('common.add', { name: _T('team.title').toLowerCase() })),
        React.createElement(AssignStartNumbers, { competition_id: competition_id, disabled: disabled }),
        React.createElement(Link, { target: "_blank", to: `/print/${competition_id}/startnumber/` },
            React.createElement(Button, { icon: React.createElement(PrinterOutlined, null) }, _T('common.print', { name: _T('team.details.team_start_number.label').toLowerCase() }))),
        React.createElement(TeamEdit, { competition_id: competition_id, visible: visibleEdit, teamItem: teamItem, onClose: () => setVisibleEdit(false), disabled: disabled })));
};
